import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useNavigate } from 'react-router-dom';
import HeroShell from '../../../components/hero/hero-shell';
import type { RootState } from '../../../reducers';
import { getCurrentListPageFromQueryUrl } from '../../../selectors/list';
import { IconArrowLeft } from '../../../styled-components/components/Icon';
import { LinkButton } from '../../../styled-components/components/LinkButton';

const ListHero = () => {
  const { t } = useTranslation('search');
  const navigate = useNavigate();
  const page = useSelector(getCurrentListPageFromQueryUrl);
  const initialRender = useSelector<RootState, boolean>((s) => !s.routing.from);

  const onGoBack = () =>
    initialRender || !document.referrer ? navigate(`/${page?.slug}`) : navigate(-1);

  if (!page) return null;

  const { image, title } = page;

  return (
    <HeroShell
      modifiers="collapse darken fade-to-bottom"
      parallax={true}
      imageDesktop={image || undefined}
      imageMobile={image || undefined}
    >
      <LinkButton
        onClick={onGoBack}
        title={t('Back to previous page', { ns: 'search', name: title })}
        $currentColor
        style={{ marginInline: 'auto' }}
      >
        <IconArrowLeft />
        {t('Back to previous page', { ns: 'search', name: title })}
      </LinkButton>
    </HeroShell>
  );
};

export default ListHero;
